import React, { Component } from 'react';
import {AppBar, Toolbar, Typography, Paper, CardContent, TextField, CardActions, Button, CircularProgress, List, ListItem, ListItemIcon} from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import './App.css';
import LoginContainer from './login';
import DashboardContainer from './dashboard';
import VerifyContainer from './verify';
import OTPContainer from './otp';

class App extends Component {
  constructor() {
    super();
    this.state = {step: 0, loading: false};
  }

  nextState() {
    this.setState({loading: true});
    setTimeout(() => {
      this.setState({step: this.state.step + 1, loading: false});
    }, 900);
  }


  render() {
    return (
      <div className="App">
        <CssBaseline />
        <AppBar position="static">
          <Toolbar>
            <Typography variant="title" color="inherit">Texpress</Typography>
          </Toolbar>
        </AppBar>
        <div className="main-container">
          <Paper className={`card ${this.state.step == 3?"mainCard":"setupCard"}`}>
            {(this.state.loading) ? <div id="progress"><CircularProgress /> <span id="left-caption">Checking...</span></div> :
             (this.state.step == 0) ? <LoginContainer done={this.nextState.bind(this)} /> :
             (this.state.step == 1) ? <VerifyContainer done={this.nextState.bind(this)} /> :
             (this.state.step == 2) ? <OTPContainer done={this.nextState.bind(this)} /> :
             (this.state.step == 3) ? <DashboardContainer connected={false} done={this.nextState.bind(this)} /> : ""}
          </Paper>
        </div>
      </div>
    );
  }
}

export default App;
